import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';

/** Set `VITE_GOOGLE_MAPS_API_KEY` in `.env`. */
const API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

const libraries = ['geometry', 'drawing', 'places'];

const mapContainerStyle = {
  height: '400px',
  width: '100%',
  borderRadius: '20px',
};

const defaultCenter = { lat: 43.082857, lng: -89.3676184 };

export function Map({ location, handleClick, readOnly = false }) {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: API_KEY ?? '',
    libraries,
  });

  const lat =
    location?.latitude != null ? Number(location.latitude) : defaultCenter.lat;
  const lng =
    location?.longitude != null
      ? Number(location.longitude)
      : defaultCenter.lng;

  const onMapClick = (e) => {
    if (readOnly || !handleClick || !e.latLng) {
      return;
    }
    handleClick({
      ...location,
      latitude: e.latLng.lat(),
      longitude: e.latLng.lng(),
    });
  };

  if (loadError) {
    return (
      <div style={{ ...mapContainerStyle, padding: '1rem' }}>
        Map could not be loaded.
      </div>
    );
  }

  if (!isLoaded) {
    return <div style={mapContainerStyle} />;
  }

  return (
    <GoogleMap
      mapContainerStyle={mapContainerStyle}
      zoom={17}
      center={{ lat, lng }}
      onClick={onMapClick}
    >
      {lat != null && lng != null && <Marker position={{ lat, lng }} />}
    </GoogleMap>
  );
}
